import { createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#4c004c",
    },
    secondary: {
      main: "#4c004c",
    },
    white: {
      main: "#000000",
    },
    cream: {
      main: "#f2f0f0",
    },
  },
  typography: {
    fontFamily: "Poppins",
  }
});
